import LnAuth from './auth';

export { LnAuth };

export default { LnAuth };
